import { render, staticRenderFns } from "./ScreenPelvicaTransvaginalUtero.vue?vue&type=template&id=b669ffc6&scoped=true&"
import script from "./ScreenPelvicaTransvaginalUtero.vue?vue&type=script&lang=js&"
export * from "./ScreenPelvicaTransvaginalUtero.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPelvicaTransvaginalUtero.vue?vue&type=style&index=0&id=b669ffc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669ffc6",
  null
  
)

export default component.exports